import { allowedFileTypes } from '@/_shared';

import { fileToUrl, getImageSize } from './components';

export const IMAGE_FILE_TYPE_ACCEPTANCE = [...allowedFileTypes.imageOnly].join(', ');

const IMAGE_ALLOWED_FILE_TYPES = [...allowedFileTypes.imageOnly];
const DOCUMENT_ALLOWED_FILE_TYPES = [...allowedFileTypes.filesOnly];

export const SIZE_LIMIT_NUMBER = 6;
export const MAX_FILE_SIZE = SIZE_LIMIT_NUMBER * 1024 * 1024;

export async function fileValidation(
  file: File,
  maxWidth?: number,
  maxHeight?: number,
  width?: number,
  height?: number,
  accept: string = IMAGE_FILE_TYPE_ACCEPTANCE,
  sizeLimitNumber: number = SIZE_LIMIT_NUMBER
) {
  const imgSize = await getImageSize(fileToUrl(file));
  const { width: calcWidth, height: calcHeight } = imgSize;
  const fileMaxSize = sizeLimitNumber * 1024 * 1024;

  const allowedFileTypes = accept.includes('application/pdf') ? DOCUMENT_ALLOWED_FILE_TYPES : IMAGE_ALLOWED_FILE_TYPES;

  if (file.size > fileMaxSize) {
    return 'SIZE_LIMIT_REACHED';
  }

  if (!allowedFileTypes.includes(file.type)) {
    return 'INVALID_FILE_TYPE';
  }

  if (file.type.toLowerCase().indexOf('svg') < 0) {
    if (maxWidth && calcWidth >= maxWidth) {
      return 'WIDTH_LIMIT_REACHED';
    }
    if (maxHeight && calcHeight >= maxHeight) {
      return 'HEIGHT_LIMIT_REACHED';
    }
    if ((height && height !== calcHeight) || (width && width !== calcWidth)) {
      return 'DIMENSION_MISMATCH';
    }
  }

  return undefined;
}

// else if (fileTypeAcceptance === '.pdf') {
//   if (selectedFiles[0].type !== 'application/pdf') {
//     setFileIssueState('Only .pdf files are accepted.');
//   }
// }
